import { cssInterop } from "nativewind";
import { FunctionComponent } from "react";

export function nativewindWrapSvg(svg: FunctionComponent<any>) {
    return cssInterop(svg, {
        className: {
            target: 'style', // map className->style
            nativeStyleToProp: {
                // For some reason, fill is missing from the type definitions even though it works
                // @ts-ignore
                fill: 'fill',
                stroke: 'stroke'
            },
        },
    });
}